<template>
    <div class="customer-group-subcustomer-order-form-page-2">
        <div class="row">
            <div class="col-md-12">
                <div class="h4">
                    Votre panier
                </div>

                <table class="table table-sm table-bordered">
                    <template v-for="mainCategory in orderedProductsByMainCategory">
                        <tr>
                            <th>{{ mainCategory.category.name }}</th>
                            <th class="text-center">P.U.</th>
                            <th class="text-center">Qté</th>
                            <th class="text-center">Sous-total TTC</th>
                        </tr>
                        <template v-for="category in mainCategory['productsBySubCategory']">
                            <OrderProductLine
                                v-for="product in category['products']"
                                :key="product.sku"
                                :sku="product.sku"
                                :label="product.name"
                                :unit-price="parseFloat(product.price.amountTaxesInc)"
                                v-model="product.nb_ordered"
                                :readonly="true"
                                :highlight="false"
                            />
                            <tr>
                                <th colspan="4"></th>
                            </tr>
                        </template>
                    </template>
                    <tr>
                        <td class="font-weight-bold text-right" colspan="3">
                            Total TTC
                        </td>
                        <td class="text-right">{{ formatPrice(totalAmount) }} €</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="form-group row">
            <label for="customer" class="col-md-3 col-form-label">Lieu de retrait</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="customer" :value="order.customer.name" readonly>
            </div>
        </div>

        <div class="form-group row">
            <label for="delivery_date" class="col-md-3 col-form-label">Date de livraison</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="delivery_date" :value="formattedDeliveryDate" readonly>
            </div>
        </div>

        <div v-if="customerHasPickupPoints" class="form-group row">
            <label for="pickup_point" class="col-md-3 col-form-label">Lieu de retrait</label>
            <div class="col-md-9">
                <select class="form-control" id="pickup_point" v-model="pickupPointSelected">
                    <option :value="null">Choisissez le lieu de retrait</option>
                    <option v-for="pickupPoint in order.customer.meta.pickup_points" :key="pickupPoint.uuid" :value="pickupPoint.uuid">{{ pickupPoint.name }}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <ErrorsZone :errors="errors"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <hr>

                <button type="button" class="btn btn-outline-dark float-left" @click="onClickBack" :disabled="sending">
                    <i class="fas fa-chevron-left"></i> Retourner au panier
                </button>

                <div class="ml-3">
                    <button type="button" class="btn btn-success float-right" @click="onClickSubmit" :disabled="sending || !canClickSubmit">
                        <template v-if="sending">
                            <i class="fad fa-fw fa-spinner fa-spin"></i>
                            Redirection en cours...
                        </template>
                        <template v-else>
                            <i class="fad fa-fw fa-check"></i>
                            Passer la commande
                        </template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {momentDay} from "../../moment-with-helpers";
import {usePostRequest} from "../compositions/axios/postRequest"
import {orderedProductsByMainCategory} from "../../orders-utils";
import {formatPrice} from "../../helpers";

import ErrorsZone from "../ErrorsZone.vue";
import OrderProductLine from "../OrderProductLine";

export default {
    components: {
        ErrorsZone,
        OrderProductLine,
    },

    setup(props) {
        const useMethod = usePostRequest();

        const sending = useMethod.loading;
        const errors = useMethod.errors;
        const send = useMethod.post;

        return {
            sending,
            errors,
            send,
        };
    },

    props: {
        categoriesMainCategory: {
            type: Object,
            required: true,
        },
        categoriesById: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: false,
        },
        orderedProducts: {
            type: Object,
            required: true,
        },
        action: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            pickupPointSelected: null,
        };
    },

    methods: {
        onClickBack() {
            this.$emit('back');
        },

        async onClickSubmit() {
            let orderedProductsArray = [];
            for (const sku in this.orderedProducts) {
                orderedProductsArray.push({
                    sku,
                    quantity: this.orderedProducts[sku].nb_ordered,
                });
            }

            const response = await this.send(this.action, {
                products: orderedProductsArray,
                cart_id: localStorage.getItem('cart_id'),
                pickup_point: this.pickupPointSelected,
            });

            if (response && response.success) {
                if (response.redirect) {
                    window.location = response.redirect;
                }
            }
        },

        formatPrice,
    },

    computed: {
        customerHasPickupPoints() {
            return this.order.customer.meta.pickup_points?.length > 0;
        },

        canClickSubmit() {
            if (this.customerHasPickupPoints && !this.pickupPointSelected) {
                return false;
            }
            return true;
        },

        totalAmount() {
            let total = 0.0;
            if (this.orderedProducts) {
                for (const sku in this.orderedProducts) {
                    if (this.orderedProducts[sku].nb_ordered > 0) {
                        total += this.orderedProducts[sku].nb_ordered * parseFloat(this.orderedProducts[sku].price.amountTaxesInc).toFixed(2);
                    }
                }
            }
            return total;
        },

        formattedDeliveryDate() {
            return momentDay(this.order.delivery_date).format('dddd Do MMMM YYYY');
        },

        orderedProductsByMainCategory,
    }
}
</script>
